<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="save" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-active="isProductsByExcelModalVisible" :vm-title="$t('products.by_excel')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      div#spreadsheet
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
import jspreadsheet from 'jspreadsheet-ce'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')

export default {
  name: 'ModalLabelProductsByExcel',
  components: {
  },
  mixins: [ModalMixin1],
  data: () => ({
    spreadsheet: [],
    spread: null
  }),
  computed: {
    ...mapGetters(['isProductsByExcelModalVisible'])
  },
  watch: {
    isProductsByExcelModalVisible (value) {
      if (value) {
        // Timeout is needed to render the spreadsheet, because the modal is not visible yet
        setTimeout(() => {
          this.renderSpreadsheet()
        }, 1)
      } else {
        this.cleanSpreadsheet()
      }
    }
  },
  methods: {
    ...mapActions([
      'setProductsByExcelModalVisible',
      'validateProducts'
    ]),
    close () {
      this.setProductsByExcelModalVisible(false)
    },
    renderSpreadsheet () {
      this.spread = jspreadsheet(document.getElementById('spreadsheet'), {
        data: this.spreadsheet,
        minDimensions: [1, 1],
        allowInsertRow: true,
        allowManualInsertRow: true,
        allowInsertColumn: false,
        columns: [
          { title: 'Codigo', width: 200 },
          { title: 'Cantidad', width: 200 },
          { title: 'Productos por etiqueta', width: 200 }
        ],
        filters: false,
        allowComments: true
      })
    },
    cleanSpreadsheet () {
      this.spreadsheet = []
      this.spread.destroy()
    },
    async save () {
      const details = this.spread.getData().map(item => {
        return {
          code: item[0],
          quantity: item[1],
          products_by_label: item[2]
        }
      }).filter(item => item.code !== '')
      await this.validateProducts({ convertedDetails: details })
      this.cleanSpreadsheet()
      this.close()
    }
  }
}
</script>
